import React from "react";
import { ScreenshotHelperOverlay } from "components/util/helpers/screenshot_helper/ScreenshotHelper";

// Arms the screenshot helper over a prototype preview. The prototype is rendered inside
// a same-origin iframe, so what the user points at only exists in the frame's own
// realm — that is where the elements are found and rasterized — while the outline and
// the comment box are drawn out here, in the document that has this app's styles.
//
// Only the drag selection is offered: a prototype's markup is generated, so its nodes
// carry no meaning worth pointing at, and picking one by accident framed the wrong
// thing more often than it framed the right one.
const PrototypeScreenshot = ({
  frameRef,
  onCancel,
  onCapture,
}) => {

  const frameElement = frameRef.current;
  const rootNode = frameElement?.contentDocument?.body;

  if (!rootNode) return null;

  return (
    <ScreenshotHelperOverlay
      frameElement={frameElement}
      rootNode={rootNode}
      onCancel={onCancel}
      onCapture={onCapture}
    />
  );

};

export default PrototypeScreenshot;
